import { wrapper, mark, EditorUtils, icon } from '@ssml-editor/vue';

const breakRenderElement = ({
  element,
  children,
  attributes,
  editor
}) => {
  const node = element;
  return wrapper(
    attributes,
    mark(
      node.mark,
      void 0,
      { "background-color": "var(--cosy-voice-break)" },
      void 0,
      ["iconfont-ssml-editor", "icon-ssml-editor-close-fill"],
      {
        onClick: (event) => {
          event.stopPropagation();
          EditorUtils.removeByNode(editor, node);
        }
      }
    ),
    icon(children, ["iconfont-ssml-editor", "icon-ssml-editor-tingdun-fill"], {
      color: "var(--cosy-voice-break)"
    })
  );
};

export { breakRenderElement };
//# sourceMappingURL=render-element.js.map
